import axios from 'axios';
import { getApiGatewayBaseUrl } from 'helpers/api';

const baseUrl = getApiGatewayBaseUrl();

const getDoctors = ({
  latitude,
  longitude,
  language,
  page = 1,
  limit = 5,
}: any) => {
  const params = `search[latitude]=${latitude}&search[longitude]=${longitude}&search[range]=${limit}&page=${page}`;
  return axios.get(`${baseUrl}/daba-doc/${language}/search?${params}`);
};

export default {
  getDoctors,
};
